<template>
  <div class="home">
    <vue-title title="WOLF | Home" />
    <Header />
    <div class="container">
      <h3
        :class="{
          light: !isDarkMode,
          dark: isDarkMode
        }"
      >
        Home
      </h3>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import VueTitle from "@/components/VueTitle";

export default {
  name: "home",
  components: {
    Header,
    VueTitle
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-left: 25px;
}

h3.light {
  @include heading3();
}

h3.dark {
  @include heading3($black);
}
</style>
